<!-- component that shows profile attributes at profile list -->
<template>
  <div class="flex flex-column h100 overflow-y">
    <div v-if="'userId' in profile" class="max-width-1 mx-auto my4 center">
      <div v-if="usersOwnProfile.userId === profile.userId">
        <h1 class="mt0 mb2">Omat tiedot</h1>
        <p class="h5">Tiedot näytetään asiakkaalle kun aloitat keskustelun.</p>
      </div>
      <div v-else>
        <h1 class="mt0 mb1">Käyttäjän {{profile.firstName}} tiedot</h1>
        <div class="semibold" v-if="profile.userId">{{(companyById(profile.company) || {}).name || 'Kumppanitieto puuttuu'}}</div>
        <div class="h5" v-if="profile.email">
          <div class="mb2">Kirjautunut viimeksi: {{getLastLoginDate(this.profile.lastLoginAt)}}</div>
          <div v-if="usersOwnProfile.superUser">
            <v-button v-if="profile.active && !showDeactivateButton" @click="startDeactivating" variant="link">Estä käyttäjän pääsy palveluun</v-button>
            <div v-if="profile.active && showDeactivateButton">
              <font color="red">Haluan estää käyttäjän pääsyn palveluun</font>
              <div><v-button variant="link red" @click="deactiveAccount">KYLLÄ</v-button></div>
              <div><v-button variant="link" @click="dontDeactiveAccount">EI</v-button></div>
            </div>
            <v-button v-if="!profile.active" variant="link" @click="activeAccount">Salli käyttäjän pääsy palveluun</v-button>
            <div v-if="profile.active" class="superUser-holder">
              <v-button v-if="profile.superUser" variant="link" @click="removeSuperUserRights">Poista pääkäyttäjä oikeudet</v-button>
              <v-button v-else variant="link" @click="giveSuperUserRights">Anna pääkäyttäjän oikeudet</v-button>
            </div>
          </div>
        </div>
      </div>
      <div class="mt3">
        <picture-input
          ref="pictureInput"
          @change="onChange"
          width="256"
          height="256"
          margin="16"
          radius="50"
          size="11"
          :prefill="profileImage(profile.image)"
          buttonClass="button primary"
          removeButtonClass="button"
          :custom-strings="{
            upload: '<p>Laitteesi ei tue tiedostonlatausta.</p>',
            drag: 'Raahaa kuva tähän<br>tai klikkaa ja valitse tiedosto.',
            tap: 'Napauta tässä ja<br>valitse kuva galleriasta.',
            change: 'Vaihda kuva',
            remove: 'Poista kuva',
            select: 'Valitse kuva',
            selected: '<p>Kuvan valinta onnistui!</p>',
            fileSize: 'Tiedoston koko ylittää sallitun rajan',
            fileType: 'Tiedostomuoto ei ole sallittu.',
            aspect: 'Vaaka/pysty'
          }"
        />
      </div>
      <div class="mt3">
        <div class="col-12 mb1" v-if="usersOwnProfile.superUser">
          <label for="email" >Sähköposti*</label>
          <input v-model="email" v-if="profile.email" type="text" class="col-12" placeholder="Sähköposti (pakollinen)">
          <input v-model="email" v-else type="text" class="col-12" placeholder="Uuden käyttäjän sähköposti">
        </div>
        <div class="flex mb2">
          <div class="col-6 mr1">
            <label for="firstName">Etunimi*</label>
            <input v-model="firstName" type="text" class="col-12" placeholder="" :disabled="notAllowedToEdit()">
          </div>
          <div class="col-6 ml1">
            <label for="lastName">Sukunimi*</label>
            <input v-model="lastName" type="text" class="col-12" placeholder="" :disabled="notAllowedToEdit()">
          </div>
        </div>
        <div class="col-12 mb1" v-if="usersOwnProfile.superUser || usersOwnProfile.userId == profile.userId">
          <label for="pnumber" >Puhelinnumero*</label>
          <div class="flex input-addon">
            <input v-model="pnumber" type="text" maxlength="10" class="col-12 order-1" placeholder="40 1234567">
            <div class="flex-none">+358</div>
          </div>
        <div v-if="!validPNumber()">Puhelinnumeron muoto on väärä</div>
        <div v-if="validPNumber() && '+358'.concat(pnumber) !== profile.pnumber">Varmista että saat puhelinnumeroon lähetetyn testiviestin tallentamisen jälkeen.</div>
        </div>
        <div class="col-12 mb1">
          <label for="role">Titteli*</label>
          <input v-model="role" type="text" class="col-12" placeholder="Suomeksi (pakollinen)" :disabled="notAllowedToEdit()">
        </div>
        <div class="col-12 mb1">
          <input v-model="roleSV" type="text" class="col-12" placeholder="Ruotsiksi" :disabled="notAllowedToEdit()">
        </div>
        <div class="col-12 mb2">
          <input v-model="roleEN" type="text" class="col-12" placeholder="Englanniksi" :disabled="notAllowedToEdit()">
        </div>
        <div v-if="profile.userId !== usersOwnProfile.userId && (usersOwnProfile.iam || {}).superAdmin">
          <label for="company">Kumppani*</label>
          <div class="col-12">
            <Select v-model="company" required class="col-12" :disabled="notAllowedToEdit()" :options="companies" label="name" :clearable="false" :reduce="company => company.id"/>
          </div>
        </div>
      </div>
      <div class="flex justify-center mt3">
        <v-button v-if="this.profile.userId === this.usersOwnProfile.userId" class="mr1" @click="goBack" :disabled="notAllowedToEdit()">Poistu</v-button>
        <v-button v-else class="mr1" @click="cancel" :disabled="notAllowedToEdit()">Peruuta</v-button>
        <v-button variant="primary" :disabled="!validProfile() || notAllowedToEdit()" @click="saveProfile">Tallenna</v-button>
      </div>
    </div>
    <div v-else class="flex-auto flex items-center justify-center">
      <div class="max-width-1 center gray-3 h2">
        <svg width="68" height="68" viewBox="0 0 68 68" xmlns="http://www.w3.org/2000/svg">
          <g stroke="#A3ADB3" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linejoin="round">
            <path d="M67 34c0 18.225-14.778 33-33 33C15.772 67 1 52.225 1 34S15.772 1 34 1c18.222 0 33 14.775 33 33zM25 55h18" stroke-linecap="round"/>
            <path stroke-linecap="round" d="M28 28h6v25.5"/>
            <path d="M32.5 15a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 32.5 15z"/>
          </g>
        </svg>
        <p class="my3">Valitse käyttäjä vasemman reunan paneelista</p>
        <v-button @click="addNewUser" variant="primary" v-if="!notAllowedToEdit()">Lisää uusi käyttäjä</v-button>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from "vuex"
import Button from '@/components/Button.vue'
import Select from '@/components/Select.vue';
import PictureInput from 'vue-picture-input'
import router from '@/router';
import Util from '@/util';
import moment from 'moment';

export default {
  name: 'Profile',
  data () {
    return {
      updatedProfile: {
        firstName: null,
        lastName: null,
        role: null,
        roleSV: null,
        roleEN: null,
        company: null,
        image: null,
        email: null,
        pnumber: null,
      },
      showDeactivateButton: false,
      changed: false,
      imageChanged: false,
    };
  },
  components: {
    PictureInput,
    'v-button': Button,
    Select,
  },
  computed: {
    ...mapGetters({
      profile: 'selectedProfile',
      usersOwnProfile: 'profile',
      companies: 'companies',
      companyById: 'companyById',
    }),
    firstName: {
      get () {
        if (this.updatedProfile.firstName !== null) {
          return this.updatedProfile.firstName;
        }
        return this.profile.firstName;
      },
      set (value) {
        this.changed = true;
        this.updatedProfile.firstName = value.trim();
      }
    },
    lastName: {
      get () {
        if (this.updatedProfile.lastName !== null) {
          return this.updatedProfile.lastName;
        }
        return this.profile.lastName;
      },
      set (value) {
        this.changed = true;
        this.updatedProfile.lastName = value.trim();
      }
    },
    email: {
      get () {
        if (this.updatedProfile.email !== null) {
          return this.updatedProfile.email;
        }
        return this.profile.email;
      },
      set (value) {
        this.changed = true;
        this.updatedProfile.email = value.trim();
      }
    },
    pnumber: {
      get () {
        if (this.updatedProfile.pnumber !== null) {
          return this.updatedProfile.pnumber;
        }
        if (this.profile.pnumber) {
          const trimmedNumber = this.profile.pnumber.replace('+358','');
          return trimmedNumber;
        } else {
          return '';
        }

      },
      set (value) {
        this.changed = true;
        this.updatedProfile.pnumber = value.trim();
      }
    },
    role: {
      get () {
        if (this.updatedProfile.role !== null) {
          return this.updatedProfile.role;
        }
        return this.profile.role;
      },
      set (value) {
        this.changed = true;
        this.updatedProfile.role = value.trim();
      }
    },
    roleEN: {
      get () {
        if (this.updatedProfile.roleEN !== null) {
          return this.updatedProfile.roleEN;
        }
        return this.profile.roleEN;
      },
      set (value) {
        this.changed = true;
        this.updatedProfile.roleEN = value.trim();
      }
    },
    roleSV: {
      get () {
        if (this.updatedProfile.roleSV !== null) {
          return this.updatedProfile.roleSV;
        }
        return this.profile.roleSV;
      },
      set (value) {
        this.changed = true;
        this.updatedProfile.roleSV = value.trim();
      }
    },
    company: {
      get () {
        if (this.updatedProfile.company !== null) {
          return this.updatedProfile.company;
        }
        return (this.companyById(this.profile.company) || {}).id || '';
      },
      set (value) {
        this.changed = true;
        this.updatedProfile.company = value;
      }
    }
  },
  mounted: function() {
    this.$store.dispatch('getProfile');
  },
  methods: {
    onChange() {
      if (this.$refs.pictureInput.image) {
        this.imageChanged = true;
        this.updatedProfile.image = this.$refs.pictureInput.file;
      }
    },
    notAllowedToEdit() {
      if(this.profile.userId === this.usersOwnProfile.userId) {
        return false;
      }
      return !this.usersOwnProfile.superUser;
    },
    getLastLoginDate(date) {
      if (!date) return 'Ei koskaan';
      const parsedDate = moment(date);
      const dateString = parsedDate.format('D.M.YYYY');
      const timeString = parsedDate.format('HH:mm');
      return `${dateString} klo ${timeString}`;
    },
    addNewUser() {
      this.$store.dispatch('setNewProfile');
    },
    giveSuperUserRights() {
      this.$store.dispatch('giveSuperUserRights', this.profile.userId);
    },
    removeSuperUserRights() {
      this.$store.dispatch('removeSuperUserRights', this.profile.userId);
    },
    activeAccount() {
      this.$store.dispatch('activateProfile', this.profile.userId);
      this.showDeactivateButton = false;
    },
    deactiveAccount() {
      this.showDeactivateButton = false;
      this.$store.dispatch('deactivateProfile', this.profile.userId);
    },
    startDeactivating() {
      this.showDeactivateButton = true;
    },
    dontDeactiveAccount() {
      this.showDeactivateButton = false;
    },
    saveProfile() {
        if (this.updatedProfile.firstName === null) {
          this.updatedProfile.firstName = this.profile.firstName;
        }
        if (this.updatedProfile.lastName === null) {
          this.updatedProfile.lastName = this.profile.lastName;
        }
        if (this.updatedProfile.role === null) {
          this.updatedProfile.role = this.profile.role;
        }
        if (this.updatedProfile.roleEN === null) {
          this.updatedProfile.roleEN = this.profile.roleEN;
        }
        if (this.updatedProfile.roleSV === null) {
          this.updatedProfile.roleSV = this.profile.roleSV;
        }
        if (this.updatedProfile.company === null) {
          this.updatedProfile.company = this.profile.company;
        }
        if (this.updatedProfile.email === null) {
          this.updatedProfile.email = this.profile.email;
        }
        if (this.updatedProfile.pnumber === null) {
          this.updatedProfile.pnumber = this.profile.pnumber;
        } else {
          this.updatedProfile.pnumber = this.updatedProfile.pnumber.replace(/\s+/g, '');
          if (this.updatedProfile.pnumber.charAt(0) === '0') {
            this.updatedProfile.pnumber = this.updatedProfile.pnumber.substr(1);
          }
          this.updatedProfile.pnumber = '+358'.concat(this.updatedProfile.pnumber);
        }

      if (!this.usersOwnProfile.iam.superAdmin) {
        this.updatedProfile.company = undefined;
      }

      if(this.profile.email) {
        if (this.imageChanged) {
          this.$store.dispatch('saveProfileImage', this.updatedProfile.image);
        }
        if (this.changed) {
          this.$store.dispatch('saveProfile', this.updatedProfile);
        }
      } else {
        if (this.updatedProfile.email === null) {
          this.updatedProfile.email = this.profile.email;
        }
        this.$store.dispatch('createProfile', this.updatedProfile);
      }
      if(this.profile.userId === this.usersOwnProfile.userId) {
        router.go(-1);
      }
      this.updatedProfile = {
        firstName: null,
        lastName: null,
        role: null,
        roleSV: null,
        roleEN: null,
        company: null,
        image: null,
        email: null,
        pnumber: null,
      }
      this.changed = false;
      this.imageChanged = false;
    },
    validProfile() {
        if (!this.changed && !this.imageChanged) return false;
        if (this.usersOwnProfile.iam.superAdmin && this.usersOwnProfile.userId !== this.profile.userId && !this.company) return false;
        if (this.firstName.length === 0 || this.lastName.length === 0 || this.role.length === 0) return false;
        if (this.updatedProfile.company != null && this.updatedProfile.company.length === 0) return false;
        if (this.updatedProfile.firstName != null && this.updatedProfile.firstName.length === 0) return false;
        if (this.updatedProfile.lastName != null && this.updatedProfile.lastName.length === 0) return false;
        if (this.updatedProfile.role != null && this.updatedProfile.role.length === 0) return false;
        if (!this.validEmail() || !this.validPNumber()) return false;
        return true;
    },
    validPNumber(){
      if (this.updatedProfile.pnumber === null) {
        return (this.profile.pnumber !== null && this.profile.pnumber !== '');
      } else {
        if(this.updatedProfile.pnumber.includes('+')) {
          return false;
        }
        return this.updatedProfile.pnumber.length > 4 ? true : false
      }
    },
    validEmail(){
      if (this.updatedProfile.email == null && this.profile.email === null) {
        //case for new users
        return false;
      } else if (this.profile.email.length > 0) {
        return true;
      } else {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(this.updatedProfile.email).toLowerCase());
      }
    },
    cancel() {
      this.changed = false;
      this.imageChanged = false;
      this.updatedProfile = {
        firstName: null,
        lastName: null,
        role: null,
        roleSV: null,
        roleEN: null,
        company: null,
        pnumber: null,
        email: null,
        image: null,
      }
    },
    goBack() {
      router.push('/new');
    },
    profileImage (image) {
      if(image) {
        return Util.getProfileImageURL(image);
      } else {
        return null;
      }
    },
  }
}

</script>

<style scoped>
  .picture-inner .picture-inner-text {
    font-size: var(--h3);
    line-height: var(--line-height-3);
  }
  .superUser-holder {
    margin-top: 10px;
  }
  .input-addon > div {
    padding: var(--space-1);
    padding-right: 0;
    color: var(--dark-blue);
    font-size: var(--h5);
    border: 1px solid var(--gray-3);
    border-right: 0;
    margin-right: -1px;
    z-index: 1;
    background-color: #fff;
  }
  .input-addon > input:focus ~ div {
    border-color: var(--dark-blue)
  }
</style>
